import React, { useState, useContext, useEffect, useRef } from "react";
import { HOST_MEDIA_URL } from '../../host';
import { GlobalContext } from "../../../App";
import "../../BoundaryCanvas";
import L from "leaflet";


// currently rendering as the tools 
export default function DataVisulization() {
  const [features, setFeatures] = useState([]);
  const [propertyKeys, setPropertyKeys] = useState([]);
  const {
    map,
    openGeojSonGraph,
    setOpenGeojSonGraph,
    xProperty, setXProperty,
    yProperty, setYProperty,
    xValues, setXValues,
    yValues, setYValues
  } = useContext(GlobalContext);
  const [show, setShow] = useState(false);
  const [vectors, setVectors] = useState([]);
  const [selLayer1, setSelLayer1] = useState(null);
  const [selLayer2, setSelLayer2] = useState(null);
  const { vis, layerControls, Canvas } = useContext(GlobalContext);
  const toolRef = useRef(null);
  const [props, setProps] = useState([]);
  const [selProp, setSelProp] = useState(null);


  console.log("openGeojSonGraph:", openGeojSonGraph);
  console.log("xValues:", xValues);
  console.log("yValues:", yValues);

  
  useEffect(() => {
    if (layerControls) {
      setVectors(Canvas.getLayers());
    }
    setSelLayer1(null);
    setSelLayer2(null);
  }, [show, Canvas, layerControls]);

  useEffect(() => {
    if (selLayer1) {
      setProps(Canvas.getProps(selLayer1, false));

      //  Fix: Set the features for selected layer
      const layerData = Canvas.getLayerData(selLayer1);
      if (layerData && layerData.features) {
        setFeatures(layerData.features);
      }
    }
   
  }, [selLayer1, Canvas, ]);

  useEffect(() => {
    if (xProperty && yProperty && features.length > 0) {
      const x = [];
      const y = [];

      features.forEach(feature => {
        const props = feature.properties;
        x.push(props[xProperty]);
        y.push(props[yProperty]);
      });

      setXValues(x);
      setYValues(y);
      setOpenGeojSonGraph(true);
    }
  }, [xProperty, yProperty, features, setXValues, setYValues, setOpenGeojSonGraph]);

 return (
  <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

    {/* ── Trigger Button ── */}
    <button
      className="btn text-white"
      title="Data Visualization"
      onClick={() => setShow(!show)}
      style={{ backgroundColor: 'black', width: '40px', height: '40px', borderRadius: '50%', border: 'none' }}
    >
      <i className="fa-solid fa-chart-pie" />
    </button>

    {show && (
      <div ref={toolRef} className="toolsvis" style={{ display: "flex", flexDirection: "column", width: "220px", padding: "10px 12px" }}>

        {/* ── Header ── */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          paddingBottom: "8px", marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.12)"
        }}>
          <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
            <i className="fa-solid fa-chart-pie" style={{ marginRight: "6px", fontSize: "11px" }} />
            Data Visualization
          </span>
          <span
            onClick={() => setShow(false)}
            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        {/* ── Selects ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="toolsvis-body"> 
          <select
            onChange={(e) => setSelLayer1(e.target.value)}
            value={selLayer1 || ""}
            className="form-select"
            style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
          >
            <option value="">Select Layer</option>
            {vectors.map((comp) => (
              <option key={comp} value={comp}>{comp}</option>
            ))}
          </select>
         </div>
          {selLayer1 && props.length > 0 && (
            <>
              <select
                onChange={(e) => setXProperty(e.target.value)}
                value={xProperty || ""}
                className="form-select text-white"
                style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
              >
                <option value="" >X-axis Property</option>
                {props.map((comp) => (
                  <option key={comp} value={comp}>{comp}</option>
                ))}
              </select>

              <select
                onChange={(e) => setYProperty(e.target.value)}
                value={yProperty || ""}
                className="form-select text-white"
                style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
              >
                <option value="">Y-axis Property</option>
                {props.map((comp) => (
                  <option key={comp} value={comp}>{comp}</option>
                ))}
              </select>
            </>
          )}

        </div>
      </div>
    )}
  </div>
);
}
